import {UI} from "../../../../../../stem-core/src/ui/UIBase";
import {StyleSheet} from "../../../../../../stem-core/src/ui/Style";
import {Messages} from "../../../../../Messages";
import {styleRule} from "../../../../../../stem-core/src/decorators/Style";
import {registerStyle} from "../../../../../../stem-core/src/ui/style/Theme";
import {LabeledCheckbox} from "../../../../../ui/Checkbox";
import {MerchantCheckbox} from "../../../../../widget/ui/MerchantCheckbox";
import {NOOP_FUNCTION} from "../../../../../../blink-sdk/utils/Utils";
import {CardForm} from "../../donation/components/CardForm";
import {paymentMethodController} from "../../../../inline-donation/PaymentMethodController";
import {iFrameMerchantService} from "blinkpay/services/IframeMerchantService";


export class PayWithAddedCardComponentStyle extends StyleSheet {
    @styleRule
    title = this.themeProps.INLINE_DONATE_FLOW_TITLE;

    @styleRule
    checkbox = this.themeProps.INLINE_DONATE_FLOW_CHECKBOX;
}

@registerStyle(PayWithAddedCardComponentStyle)
export class PayWithAddedCardComponent extends UI.Element {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            onChange: NOOP_FUNCTION,
            testId: "payWithAddedCard",
            CardFormClass: CardForm,
            checkboxLabel: Messages.saveCardDetailsCheckbox,
            title: Messages.payWithAddedCardComponentTitle
        };
    }

    render() {
        const {styleSheet} = this;
        const {CardFormClass, checkboxLabel, title} = this.options;

        return [
            <div className={styleSheet.title}>{title}</div>,
            <CardFormClass ref="cardForm" onChange={this.options.onChange}/>,
            !iFrameMerchantService.isCDSPaymentMethod() && paymentMethodController.showSaveCardCheckbox ?
                <LabeledCheckbox ref="storeCardCheckbox" testId="storeCardCheckbox"
                                 className={styleSheet.checkbox} CheckboxClass={MerchantCheckbox}
                                 initialValue={paymentMethodController.savePaymentMethod} label={checkboxLabel}
                                 onChange={enabled => {paymentMethodController.savePaymentMethod = enabled;}}/> : null
        ];
    }

    isValid() {
        return this.cardForm.isValid();
    }

    getPaymentMethodId(scope, callback, errorCallback) {
        if (this.storeCardCheckbox && this.storeCardCheckbox.getValue()) {
           this.cardForm.confirmCard(card => callback(card.id), errorCallback);
        } else {
             if (iFrameMerchantService.isCDSPaymentMethod()) {
                 this.cardForm.confirmCardWithoutStoring(scope, card => callback(card), errorCallback);
            } else {
                 this.cardForm.confirmCardWithoutStoring(scope, card => callback(card.id), errorCallback);
            }
        }
    }
}
